import React from "react";
import { FaRegCircle } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";
import { GroupStepsDTO } from "../../typings/uicomponents";

const GroupSteps: React.FC<GroupStepsDTO> = ({
  items,
  onItemClick,
  currentitem,
}) => {
  return (
    <div className=" flex ">
      {items.map((item, key) => (
        <div className="flex justify-center items-center">
          <div
            className={`  ${
              currentitem == item.index ? " border border-primary" : ""
            } px-6 py-3 rounded-full shadow  ${
              currentitem> item.index ? "  bg-primary text-white" : " bg-white  "
            } `}
            onClick={() => {
              // onItemClick(item.index);
            }}
          >
            { currentitem > item.index ?< FaCircleCheck className="inline" />:<FaRegCircle className="inline"/>}  
            <p className="font-medium text-[13px] inline cursor-pointer ">
              {" "}
              {item.title}
            </p>
          </div>{" "}
          {!(key + 1 == items.length) ? (
            <hr className="bg-gray-300 w-[102px] h-[2px]" />
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
};
export { GroupSteps };
